module.exports = __webpack_public_path__ + "img/emoji-handwithphone-240x240.cf58b5ed.png";